import { render, staticRenderFns } from "./serverTpc.vue?vue&type=template&id=9891cc50&scoped=true"
import script from "./serverTpc.vue?vue&type=script&lang=js"
export * from "./serverTpc.vue?vue&type=script&lang=js"
import style0 from "./serverTpc.vue?vue&type=style&index=0&id=9891cc50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9891cc50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9891cc50')) {
      api.createRecord('9891cc50', component.options)
    } else {
      api.reload('9891cc50', component.options)
    }
    module.hot.accept("./serverTpc.vue?vue&type=template&id=9891cc50&scoped=true", function () {
      api.rerender('9891cc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/dcopsTicket/serverTpc.vue"
export default component.exports